import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Ripple } from "primereact/ripple";

import Ban from "../assets/images/Screen.png";
import ClientLogo from "../assets/images/image.png";
import BarnksforteLogo from "../assets/images/barnksforte.png";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { loginUser } from "../redux/apiCalls";

const Login = () => {
  const { userInfo, isLoading, error } = useSelector((state) => state.user);
  const [em, setEm] = useState("");
  const [pwd, setPwd] = useState("");
  const nav = useNavigate();
  const dispatch = useDispatch();

  const login = () => {
    if (!em || !pwd) return;
    loginUser({ email: em, password: pwd }, dispatch);
  };

  useEffect(() => {
    if (userInfo) {
      nav("/");
    }
  }, [userInfo, nav]);

  return (
    <div className="surface-ground min-h-screen flex">
      <div className="surface-card flex flex-column md:flex-row w-full shadow-none overflow-hidden">
        {/* Visual Section - Maintaining Image and Overlay */}
        <div
          className="hidden md:flex md:w-6 lg:w-7 relative flex-column justify-content-end p-6 bg-no-repeat bg-cover overflow-hidden"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 71, 10, 0.4), rgba(0, 0, 0, 0.7)), url(${Ban})`,
            backgroundPosition: "center",
          }}
        >
          <div className="relative z-1 mb-8 p-4">
            <h2 className="text-white text-6xl font-bold line-height-2 mb-3">
              Robust Device Management for Enterprises.
            </h2>
            <p className="text-white-alpha-80 text-2xl font-medium line-height-3 max-w-30rem">
              Secure, monitor, and manage your mobile fleet with Barnksforte
              Technologies specialized MDM solutions.
            </p>
          </div>
          <div className="absolute top-0 left-0 w-full h-full bg-black-alpha-20"></div>
        </div>

        {/* Form Section */}
        <div className="w-full md:w-6 lg:w-5 p-5 md:p-8 surface-card flex flex-column justify-content-center">
          <div className="max-w-30rem mx-auto w-full">
            <div className="mb-6 text-center md:text-left">
              <img
                src={ClientLogo}
                alt="Logo"
                height={70}
                className="mb-4"
                style={{ objectFit: "contain" }}
              />
              <h1 className="text-900 text-5xl font-bold mb-2">Welcome Back</h1>
              <p className="text-600 font-medium text-xl">
                Please enter your credentials to continue
              </p>
            </div>

            <div className="flex flex-column gap-4">
              {error && (
                <Message
                  severity="error"
                  text={error}
                  className="w-full justify-content-start border-red-500 border-left-3 bg-red-50 text-red-700"
                />
              )}

              <div className="flex flex-column gap-2">
                <label htmlFor="email" className="text-900 font-semibold">
                  Email Address
                </label>
                <span className="p-input-icon-left">
                  <i className="pi pi-envelope text-600" />
                  <InputText
                    id="email"
                    type="email"
                    placeholder="admin@enterprise.com"
                    onChange={(e) => setEm(e.target.value)}
                    className={`w-full p-4 text-xl ${error ? "p-invalid" : ""}`}
                  />
                </span>
              </div>

              <div className="flex flex-column gap-2">
                <div className="flex align-items-center justify-content-between">
                  <label htmlFor="password" className="text-900 font-semibold">
                    Password
                  </label>
                </div>
                <span className="p-input-icon-left">
                  <i className="pi pi-lock text-600" />
                  <InputText
                    id="password"
                    type="password"
                    placeholder="••••••••"
                    onChange={(e) => setPwd(e.target.value)}
                    className={`w-full p-4 text-xl ${error ? "p-invalid" : ""}`}
                    onKeyDown={(e) => e.key === "Enter" && login()}
                  />
                </span>
              </div>

              <Button
                label="Sign In to Console"
                icon="pi pi-sign-in"
                loading={isLoading}
                onClick={login}
                className="w-full p-4 text-xl font-bold bg-green-600 border-none hover:bg-green-700 transition-all p-ripple shadow-2"
              >
                <Ripple />
              </Button>
            </div>

            <div className="mt-8 pt-6 text-center border-top-1 surface-border flex flex-column align-items-center">
              <span className="text-600 font-medium text-sm mt-3 block">
                Platform version 2.4.0 • © 2026 Barnksforte Technologies
              </span>
              <div className="mt-3 flex align-items-center justify-content-center">
                <img src={BarnksforteLogo} alt="Barnksforte Logo" height={60} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
